<script>
import Layout from "../../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import {  Dropdown } from "bootstrap";

export default {
  page: {
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
  },
  data() {
    return {
      custody_transfer_logs: [],
      donationAccounts: [],
      page: 1,
      limit: 20,
      tot_pages: 0,
      searchMode: false,
      searchModel: "",
      dropdown:null,
      filter:"all"
    };
  },
  methods: {
    
    
    search(page) {
        if(!this.searchModel.length){
            this.page =1
            return this.cancelSearchMode()
            } 
            
      this.searchMode = true;
      this.tot_pages = 0;
      this.http
        .post("emp-custody-transfer-logs/search", {
          search: this.searchModel,
          limit: this.limit,
          page: this.page,
          col: "name",
                    filter:this.filter

        })
        .then((res) => {
          this.custody_transfer_logs = res.data;
                  this.tot_pages = Math.ceil(res.tot / this.limit);
          this.page = page;

        });
    },
    cancelSearchMode() {
      this.searchModel = "";
      this.searchMode = false;
      this.get(this.page);
    },
  
    get(page) {
      console.log(page);
      this.http
        .post("emp-custody-transfer-logs/pagination", {
          limit: this.limit,
          page: page,
          filter:this.filter
        })
        .then((res) => {
          this.page = page;
          this.tot_pages = Math.ceil(res.tot / this.limit);
          this.custody_transfer_logs = res.data;
        });
    },
  },
  created() {
    this.get(1);
    // this.getAccounts()
  },
  mounted() {
        this.dropdown = new Dropdown(".dropdown-toggle.filter-assets");

  },
};
</script>

<template>
  <Layout>
    <PageHeader
      :dir="$i18n.locale == 'ar' ? 'rtl' : 'ltr'"
      :title="$t('fixed_assets.custody_transfer_logs')"
    />
    <div class="row">
      <div class="card">
        <div class="card-body">
          <div class="row">
            <div class="col-6 mb-4">
              <div class="search-box chat-search-box" style="width: 250px">
                <div class="position-relative">
                  <input
                    :dir="$i18n.locale == 'ar' ? 'rtl' : ''"
                    @input="search(page)"
                    type="search"
                    class="form-control fa-lg text-light"
                    :placeholder="$t('salaryItems.search')"
                    v-model="searchModel"
                    style="background-color: #2a3042 !important"
                  />
                  <i class="bx bx-search-alt search-icon text-light"></i>
                  
                </div>
              </div>
            </div>
            <div class="col-6" style="display: flex; justify-content: flex-end">
          <div class="mb-4">
                <div class="dropdown">
                  <button
                    class="btn btn-light dropdown-toggle filter-assets"
                    @click="dropdown.toggle"
                    data-bs-toggle="dropdown"
                  >
                    <span class="fa fa-filter"></span>
                  </button>
                  <ul class="dropdown-menu" style="z-index: 100">
                    <li>
                      <a
                        href="javascript: void(0)"
                        class="dropdown-item"
                        @click="
                          filter = 'all';
                          search
                            ? search(page)
                            : get(page);
                        "
                        >{{ $t("fixed_assets.all") }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript: void(0)"
                        class="dropdown-item"
                        @click="
                          filter = 'assign';
                          search
                            ? search(page)
                            : get(page);
                        "
                        >{{ $t("hr_custodies.transfer_logs.assign") }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript: void(0)"
                        class="dropdown-item"
                        @click="
                          filter = 'release';
                          search
                            ? search(page)
                            : get(page);
                        "
                        >{{ $t("hr_custodies.transfer_logs.release") }}</a
                      >
                    </li>
                    <li>
                      <a
                        href="javascript: void(0)"
                        class="dropdown-item"
                        @click="
                          filter = 'transfer';
                          search
                            ? search(page)
                            : get(page);
                        "
                        >{{ $t("hr_custodies.transfer_logs.transfer") }}</a
                      >
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div class="table-responsive">
            <table
              class="table table-centered table-nowrap table-striped table-hover align-middle"
            >
              <thead>
                <tr
                  class="text-light"
                  style="background-color: #2a3042 !important"
                >
                  <th scope="col">#</th>
                  <th scope="col">{{ $t("fixed_assets.created") }}</th>
                  <th scope="col">{{ $t("fixed_assets.reference_no") }}</th>
                   <th scope="col">{{ $t("fixed_assets.code") }}</th>
                  <th scope="col">{{ $t("fixed_assets.label") }}</th>
                  <th scope="col">{{ $t("fixed_assets.label_en") }}</th>
                  <th scope="col">{{ $t("hr_custodies.transfer_logs.type") }}</th>
                  <th scope="col">{{ $t("hr_custodies.transfer_logs.from") }}</th>
                  <th scope="col">{{ $t("hr_custodies.transfer_logs.to") }}</th>

                </tr>
              </thead>
              <tbody>
                <tr v-for="(app, index) in custody_transfer_logs" :key="app" class="">
                  <td>{{ (page - 1) * this.limit + index + 1 }}</td>
                  <td>{{ new Date(app.created).toLocaleString('en-GB',{hour12:true}) }}</td>
                  <td>{{  app?.reference_no  }}</td>
                  <td>{{  app?.fixed_asset_code  }}</td>
                  <td>{{  app?.fixed_asset_name  }}</td>
                  <td>{{ app?.fixed_asset_name_en }}</td>
                  <td>{{ $i18n.locale == "ar" ? app?.transfer_log_type_name : app?.transfer_log_type_name_en }}</td>
                  <td>{{ app?.from_emp_name }}</td>
                  <td>{{ app?.to_emp_name }}</td>
                  <!-- <td>
                    {{
                      (
                        parseFloat(app?.totalCredit) -
                        parseFloat(app?.totalDebit)
                      ).toLocaleString()
                    }}
                  </td> -->
                
              
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- end  table -->

    <!--   Purchases  Pagination     -->
    <ul class="pagination pagination-rounded justify-content-center mb-2">
      <li class="page-item" :class="{ disabled: page == 1 }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="get(page - 1)"
          aria-label="Previous"
        >
          <i class="mdi mdi-chevron-left"></i>
        </a>
      </li>
      <li
        class="page-item"
        :class="{ active: p == page }"
        v-for="p in tot_pages"
        :key="p"
      >
        <a class="page-link" href="javascript: void(0);" @click="get(p)">{{
          p
        }}</a>
      </li>

      <li class="page-item" :class="{ disabled: page == tot_pages }">
        <a
          class="page-link"
          href="javascript: void(0);"
          @click="get(page + 1)"
          aria-label="Next"
        >
          <i class="mdi mdi-chevron-right"></i>
        </a>
      </li>
    </ul>
    <!--end-->
  </Layout>
</template>
